import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription, interval } from 'rxjs';
@Component({
  selector: 'app-idle-dialog',
  templateUrl: './idle-dialog.component.html',
  styleUrl: './idle-dialog.component.scss'
})
export class IdleDialogComponent {

  //   data:any;
name ='sssss';
idleState = 'Not started.';
@Input() startTime: number = 60; // Initial countdown time in seconds
timeLeft: number = this.startTime;
private timerSubscription!: Subscription;
// idle.setIdle(5);
constructor(
  public dialogRef: MatDialogRef<IdleDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any,
  // private idle: Idle,
) { 
    console.log("Dialod Data::",data)
    // this.data =dialogData;
    {
      // dialogRef.updateSize('60%', 'auto'); // Decrease the width of the dialog box
    }
    this.startCountdown();
    // idle.setIdle(5);
    // idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');
  }

  // ngOnInit(): void {
    // this.startCountdown();
  // }

  startCountdown(): void {
    const countdown$ = interval(1000); // Emits every second
    this.timerSubscription = countdown$.subscribe(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timerSubscription.unsubscribe(); // Stop the timer when it reaches zero
      }
    });
  }
onNoClick(): void {
  console.log("close clicked...")
  this.data.submit_btn_clicked=false;
  this.data.stay = true;
  this.dialogRef.close(this.data);
}

onSubmitClick(): void {
  console.log("submit clicked...");
  this.data.submit_btn_clicked = true;
  this.data.stay = false;
  console.log("dialogRef::", this.dialogRef)
  if(this.dialogRef){
  this.dialogRef.close(this.data);
  }
}

ngOnInit(): void {
  console.log("this Dialod Data::",this.data)
}

}
